<pk-broker-loader [show]="loading"></pk-broker-loader>
<div class="text-center" *ngIf="!rfqSession && !loading">
	<strong>Sorry no data found for requested Pricing Session</strong>
</div>
<pk-broker-page-warnings [warnings]="warnings"></pk-broker-page-warnings>
<form [formGroup]="formGroup" *ngIf="rfqSession && !loading">
	<pk-broker-loader [show]="choosingMarketSuggestion" text="Saving selection..." extraClasses="mb-3"></pk-broker-loader>
	<pk-broker-auction-market-suggestions
		*ngIf="!choosingMarketSuggestion && (rfqSession.marketSuggestions.length > 1 || showMarketSuggestionSuccess)"
		[rfqSession]="rfqSession" [showMarketSuggestionSuccess]="showMarketSuggestionSuccess"
		(selectedMarketSuggestion)="onSelectedMarketSuggestion($event)"></pk-broker-auction-market-suggestions>
	<ng-container *ngIf="startValidation">
		<div class="alert alert-warning" *ngIf="formGroup.errors?.noSuppliers">At least one supplier is required</div>
		<div class="alert alert-warning" *ngIf="formGroup.errors?.productAmount">At least one product is required.</div>
		<div class="alert alert-warning" *ngIf="formGroup.errors?.productUnique">All products must be unique.</div>
		<div class="alert alert-warning" *ngIf="formGroup.errors?.enableShortTermPacking">Enable short term packing is required</div>
		<div class="alert alert-warning" *ngIf="formGroup.errors?.enablePacking">Enable packing is required</div>
	</ng-container>
	<div class="row">
		<div class="col-md-12 mb-4">
			<div class="card px-2 pt-2 pb-1">
				<div class="row">
					@if (loggedInUser?.isAdmin) {
					<div class="col-12 col-md-3">
						<div class="form-element-container">
							<label class="title required font-weight-bold font-size-085" for="isOnHold">On Hold</label>
							<pk-broker-form-dropdown [isRequired]="true" formControlName="isOnHold" [options]="[true, false]"
								[textMap]="yesNoTextMap">
							</pk-broker-form-dropdown>
						</div>
					</div>
					<div class="col-12 col-md-3">
						<div class="form-element-container">
							<label class="title required font-weight-bold font-size-085" for="minShortTermPackingPercent">Enable Short
								Term
								Packing</label>
							<pk-broker-form-dropdown [isRequired]="true" formControlName="enableShortTermPacking"
								[options]="[true, false]" [textMap]="yesNoTextMap">
							</pk-broker-form-dropdown>
						</div>
					</div>
					}
					<div class="col-12 col-md">
						<div class="form-element-container d-inline-block ml-4">
							<label class="title font-weight-bold font-size-085">End</label>
							<p class="value mb-0">
								{{ rfqSession.formatEndDate() }} CT
								<a *ngIf="![CONSTANTS.statuses.confirmed, CONSTANTS.statuses.dropped].includes(rfqSession.contract.status)"
									href="javascript:void(0)" class="ml-2 font-weight-bold" (click)="showAuctionExtend()"
									[tooltip]="getExtendSessionMsg()" container="body">
									Extend Session
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 mb-4">
			<div class="modal-table table-responsive">
				<table class="table table-sm table-bordered table-gray">
					<thead>
						<tr>
							<th class="w-75">Bids</th>
							<th>
								Invited Suppliers
								<a *ngIf="loggedInUser.hasPermission('auction-send-supplier-message')" href="javascript:void(0)"
									class="d-inline float-right" title="Send Message" (click)="showAuctionSendMessageModal()">
									<fa-icon class="mb-0']" [icon]="['fas', 'paper-plane']"></fa-icon>
								</a>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="pt-2 valign-top">
								<table class="table table-sm table-bordered table-white">
									<thead>
										<tr class="bg-white">
											<th class="w-33">{{ rfqSession.contract.serviceType.name }} Product(s)</th>
											<th class="w-10">Green %</th>
											<th>Best Bid</th>
											<th class="w-15">Best Bid Supplier</th>
											<th *ngIf="loggedInUser.hasPermission('auction-remove-product')">&nbsp;</th>
										</tr>
									</thead>
									<tbody>
										<ng-container *ngFor="let rfqSessionProduct of rfqSessionProducts">
											<tr class="product2">
												<td class="valign-top">
													<div class="collapse-group collapsed product" style="cursor: pointer"
														[ngClass]="{ collapsed: rfqSessionProduct.shown }"
														(click)="rfqSessionProduct.shown = !rfqSessionProduct.shown">
														<fa-icon [icon]="['fas', 'angle-right']" [rotate]="rfqSessionProduct.shown ? '90' : ''"
															class="font-weight-bold mr-2">
														</fa-icon>
														<span container="body" tooltip="Click here to see bid history">
															{{ rfqSessionProduct.description }}
														</span>
													</div>
												</td>
												<td class="valign-top">{{ rfqSessionProduct.greenPercentage || 0 }}%</td>
												<td class="valign-top">
													<span>
														{{ rfqSessionProduct?.bestBids?.[0]?.bestBidIsOnHold ? '(On Hold) ' : ''
														}}{{
															(rfqSessionProduct.bestBids && rfqSessionProduct.bestBids.length
																? (rfqSessionProduct.bestBids[0].bestBid
																	| convertBidUnits: rfqSessionProduct.bestBids[0].units : rfqSession.contract.serviceTypeId)
																: 0.0
															) | number: '1.6-6'
														}}
														{{ units }}
													</span>
												</td>
												<td class="valign-top">
													<span>{{ (rfqSessionProduct.bestBids?.length ? rfqSessionProduct.bestBids[0].supplierName :
														'N/A') | shrink: 19 }}</span>
												</td>
												<td *ngIf="loggedInUser.hasPermission('auction-remove-product')">
													<a href="javascript:void(0)" class="removeProduct2"
														(click)="removeRfqSessionProduct(rfqSessionProduct)">
														<fa-icon [icon]="['fas', 'times-circle']" class="text-danger', 'mb-0" size="lg"></fa-icon>
													</a>
												</td>
											</tr>
											<tr class="collapse" [ngClass]="{ show: rfqSessionProduct.shown }"
												*ngFor="let bid of rfqSessionProduct.bids">
												<td></td>
												<td></td>
												<td class="cell-highlight">
													{{ bid.isOnHold ? '(On Hold) ' : ''
													}}{{
														bid.displayRate + rfqSession.contract.getTotalMargin(false, true, false)
															| convertBidUnits
																: (rfqSessionProduct.bestBids && rfqSessionProduct.bestBids.length ? rfqSessionProduct.bestBids[0].units : bid.units)
																: rfqSession.contract.serviceTypeId
															| number: '1.6-6'
													}}
													{{ units }} &#64; {{ bid.addDate | date: environment.dateTimeFormat }} CT
													<a *ngIf="loggedInUser.isAdmin" style="margin-left: 5px" href="javascript:void(0)"
														(click)="showAuctionBidEdit(bid)">
														<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
													</a>
													<ng-container
														*ngIf="!rfqSessionProduct.bids || !rfqSessionProduct.bids.length">N/A</ng-container>
												</td>
												<td class="cell-highlight">
													{{ bid.rfqSessionSupplier.supplier.name | shrink: 19 }}
													<ng-container *ngIf="!rfqSessionProduct.bids?.length">N/A</ng-container>
												</td>
												<td></td>
											</tr>
										</ng-container>
									</tbody>
								</table>
								<div class="footer text-left">
									<button *ngIf="loggedInUser.hasPermission('view-session-info-data')" href="javascript:void(0)"
										class="btn btn-link p-0 ml-2 mb-2"
										tooltip="Downloads all the contract and customer information into an excel file." container="body"
										(click)="downloadRfpData()" [disabled]="rfpDataButtonDisabled">
										<fa-icon [icon]="['fas', 'download']"></fa-icon> {{ rfpDataButtonText }}
									</button>
									<button href="javascript:void(0)" class="btn btn-link p-0 ml-2 mb-2"
										tooltip="Downloads all the bid session information into an excel file." container="body"
										(click)="downloadBidSession()" [disabled]="bidSessionDataButtonDisabled">
										<fa-icon [icon]="['fas', 'download']"></fa-icon> {{ bidSessionDataButtonText }}
									</button>
									<a *ngIf="
											hasBestBid &&
											![CONSTANTS.statuses.confirmed, CONSTANTS.statuses.dropped].includes(rfqSession.contract.status) &&
											!isEnterpiseAgent
										"
										[routerLink]="['/rates', 'quote', rfqSession.contract.contractId, 'rfqSession', rfqSession.rfqSessionId]"
										target="_blank"
										style="color: white !important"
										class="btn btn-success px-4 ml-2"
										id="btnCreateQuote">
										Create Quote
									</a>
								</div>
							</td>
							<td class="pt-2 valign-top font-size-075">
								<p class="supplier m-0 p-0" *ngFor="let rfqSessionSupplier of rfqSession.suppliers; let i = index">
									<span style="flex-grow: 1; display: inline-flex;">
										<ng-container *ngIf="loggedInUser.hasPermission('auction-enter-manual-bids')">
											<a class="supplier-name" href="javascript:void(0)"
												[ngClass]="{ 'line-through': rfqSessionSupplier.isOptOut || rfqSessionSupplier.isOnHold }"
												(click)="showAuctionSupplierCreateBids(rfqSessionSupplier)" tooltip="{{ rfqSessionSupplier.supplier.name }}" container="body">{{ rfqSessionSupplier.supplier.name
												}}</a>&nbsp;</ng-container>
										<ng-container *ngIf="!loggedInUser.hasPermission('auction-enter-manual-bids')">
											<span [ngClass]="{ 'line-through': rfqSessionSupplier.isOptOut || rfqSessionSupplier.isOnHold }"
												[attr.title]="
													rfqSessionSupplier.supplier.name +
													(rfqSessionSupplier.isOptOut ? ' - Opt out' : '') +
													(rfqSessionSupplier.isOnHold ? ' - On hold' : '')
												" tooltip="{{ rfqSessionSupplier.supplier.name }}" container="body">{{ rfqSessionSupplier.supplier.name }}</span>&nbsp;</ng-container>(<ng-container
											*ngIf="rfqSessionSupplier.isOptOut"><span class="text-muted">Opt
												Out | </span>
										</ng-container><ng-container *ngIf="rfqSessionSupplier.isOnHold"><span class="text-muted">On
												Hold | </span>
										</ng-container><span tooltip="{{ rfqSessionSupplier.bids?.length ?? 0 }} bids" container="body">{{
											rfqSessionSupplier.bids?.length ?? 0 }}</span><a
											*ngIf="loggedInUser.isAdmin && rfqSessionSupplier.bids?.length" href="javascript:void(0)"
											class="no-right-margin" (click)="showAuctionSupplierBids(rfqSessionSupplier)">
											<fa-icon [icon]="['fas', 'pencil-alt']" class="ml-1 font-size-075"></fa-icon></a>)
									</span>
									<ng-container *ngIf="loggedInUser.isAdmin">
										<a *ngIf="!rfqSessionSupplier.loading && !rfqSessionSupplier.isOptOut && !rfqSessionSupplier.isOnHold"
											href="javascript:void(0)" class="d-inline no-right-margin"
											[attr.title]="'Opt-Out ' + rfqSessionSupplier.supplier.name"
											(click)="showOptOutModal(rfqSessionSupplier)">
											<fa-icon [icon]="['fas', 'user-slash']" class="text-danger font-size-085" size="sm"></fa-icon>
										</a>
										<a *ngIf="rfqSessionSupplier.loading && !rfqSessionSupplier.isOptOut && !rfqSessionSupplier.isOnHold"
											class="no-right-margin">
											<fa-icon [icon]="['fas', 'spinner']" animation="spin" size="sm"></fa-icon>
										</a>
									</ng-container>
									<ng-container
										*ngIf="rfqSession.contract.status !== 95 && loggedInUser.hasPermission('auction-delete-supplier')">
										<a *ngIf="!rfqSessionSupplier.loading" href="javascript:void(0)" class="d-inline no-right-margin"
											[attr.title]="'Remove ' + rfqSessionSupplier.supplier.name"
											(click)="removeRfqSessionSupplier(rfqSessionSupplier, i)">
											<fa-icon [icon]="['fas', 'times-circle']" class="text-danger font-size-085 ml-1"
												size="sm"></fa-icon>
										</a>
										<a *ngIf="rfqSessionSupplier.loading"><fa-icon [icon]="['fas', 'spinner']" animation="spin"
												size="sm"></fa-icon></a>
										<div class="clearfix"></div>
									</ng-container>
								</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<ng-container *ngIf="loggedInUser.hasPermission('auction-update-session')">
		<div class="row">
			<div class="col-sm-12 mb-4">
				<div class="modal-table table-responsive" style="overflow-x: unset">
					<table class="table table-sm table-bordered table-gray">
						<thead>
							<tr>
								<th class="w-75">{{ rfqSession.contract.serviceType.name }} Products</th>
								<th>Other Suppliers</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="pt-2 valign-top">
									<div class="modal-table table-responsive" style="overflow-x: unset">
										<table class="table table-sm table-bordered table-white">
											<thead>
												<tr class="bg-white">
													<th width="250">Type</th>
													<th>Term</th>
													<th>Green %</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<ng-container formArrayName="products" *ngFor="let product of form.products; let i = index">
													<tr class="product" [formGroupName]="i" *ngIf="!product.hidden.value">
														<td>
															<div class="form-element-container mb-0">
																<pk-broker-form-dropdown formControlName="type" [options]="products" textKey="name"
																	valueKey="productId">
																</pk-broker-form-dropdown>
															</div>
														</td>
														<td>
															<div class="form-element-container mb-0">
																<pk-broker-form-dropdown formControlName="term" [options]="terms"
																	[textMap]="termTextMap"></pk-broker-form-dropdown>
															</div>
														</td>
														<td>
															<div class="form-element-container mb-0">
																<pk-broker-form-dropdown formControlName="greenPercentage" [options]="greenPercentages"
																	[textMap]="greenPercentageTextMap">
																</pk-broker-form-dropdown>
															</div>
														</td>
														<td>
															<a href="javascript:void(0)" class="removeProduct"
																(click)="form.products.remove(product)">
																<fa-icon [icon]="['fas', 'times-circle']" class="text-danger', 'mb-0"
																	size="lg"></fa-icon>
															</a>
														</td>
													</tr>
												</ng-container>
											</tbody>
										</table>
									</div>
									<div class="footer">
										<a class="btn btn-link py-0 px-2 mb-2" id="addProduct" href="javascript:void(0)"
											(click)="addProduct()">
											<fa-icon [icon]="['fas', 'plus-circle']"></fa-icon> Add a row
										</a>
									</div>
									<span class="form-text"
										*ngIf="rfqSession.contract.serviceTypeId === CONSTANTS.serviceTypes.electricity.serviceTypeId">
										<strong>{{ productNote }}</strong>
									</span>
								</td>
								<td class="pt-2 valign-top enhance-checkboxes" *ngIf="loggedInUser?.isAdmin">
									<label>Click the checkboxes below and then Update Session to add them to the Pricing
										Session.</label><br />
									<label class="font-weight-bold">Outside Usage Threshold</label><br />
									<ng-container formArrayName="otherSuppliers"
										*ngFor="let supplier of form.otherSuppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<div class="custom-control custom-checkbox">
												<input class="custom-control-input" type="checkbox"
													id="suppliers-{{ supplier.supplierId.value }}" formControlName="supplierSelected" />
												<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
													{{ supplier.name.value }}
												</label>
											</div>
										</div>
									</ng-container>
									<label class="font-weight-bold">Opted Out Suppliers</label><br />
									<ng-container formArrayName="optedOutSuppliers"
										*ngFor="let supplier of form.optedOutSuppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<div class="custom-control custom-checkbox">
												<input class="custom-control-input" type="checkbox"
													id="suppliers-{{ supplier.supplierId.value }}" formControlName="supplierSelected" />
												<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
													{{ supplier.name.value }}
												</label>
											</div>
										</div>
									</ng-container>
									<label class="font-weight-bold">On Hold Suppliers
										<a href="javascript:void(0)" tooltip="On Hold suppliers require an LOA." container="body"
											placement="top"><fa-icon [icon]="['fas', 'info-circle']"></fa-icon></a></label><br />
									<ng-container formArrayName="onHoldSuppliers"
										*ngFor="let supplier of form.onHoldSuppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<div class="custom-control custom-checkbox">
												<input class="custom-control-input" type="checkbox"
													id="suppliers-{{ supplier.supplierId.value }}" formControlName="supplierSelected" />
												<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
													{{ supplier.name.value }}
												</label>
											</div>
										</div>
									</ng-container>
									<label class="font-weight-bold">Not Invited Suppliers</label><br />
									<ng-container formArrayName="suppliers" *ngFor="let supplier of form.suppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<div class="custom-control custom-checkbox">
												<input class="custom-control-input" type="checkbox"
													id="suppliers-{{ supplier.supplierId.value }}" formControlName="supplierSelected" />
												<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
													{{ supplier.name.value }}
												</label>
											</div>
										</div>
									</ng-container>
								</td>
								<td class="pt-2 valign-top enhance-checkboxes" *ngIf="!loggedInUser?.isAdmin">
									<label class="font-weight-bold">Not Invited Suppliers </label><br />
									<ng-container formArrayName="otherSuppliers"
										*ngFor="let supplier of form.otherSuppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<div class="custom-control custom-checkbox">
												<input class="custom-control-input" type="checkbox"
													id="suppliers-{{ supplier.supplierId.value }}" formControlName="supplierSelected" />
												<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
													{{ supplier.name.value }}
												</label>
											</div>
										</div>
									</ng-container>
									<ng-container formArrayName="optedOutSuppliers"
										*ngFor="let supplier of form.optedOutSuppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<div class="custom-control custom-checkbox">
												<input class="custom-control-input" type="checkbox"
													id="suppliers-{{ supplier.supplierId.value }}" formControlName="supplierSelected" />
												<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
													{{ supplier.name.value }}
												</label>
											</div>
										</div>
									</ng-container>
									<ng-container formArrayName="suppliers" *ngFor="let supplier of form.suppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<div class="custom-control custom-checkbox">
												<input class="custom-control-input" type="checkbox"
													id="suppliers-{{ supplier.supplierId.value }}" formControlName="supplierSelected" />
												<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
													{{ supplier.name.value }}
												</label>
											</div>
										</div>
									</ng-container>
									<label class="font-weight-bold">On Hold Suppliers
										<a href="javascript:void(0)" tooltip="On Hold suppliers require an LOA." container="body"
											placement="top"><fa-icon [icon]="['fas', 'info-circle']"></fa-icon></a></label><br />
									<ng-container formArrayName="onHoldSuppliers"
										*ngFor="let supplier of form.onHoldSuppliers; let i = index">
										<div class="form-element-container p-0 mt-0" [formGroupName]="i" *ngIf="!supplier.hidden.value">
											<label class="custom-control-label" for="suppliers-{{ supplier.supplierId.value }}">
												{{ supplier.name.value }}
											</label>
										</div>
									</ng-container>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12 mb-3">
				<div class="modal-table table-responsive">
					<table class="table table-sm table-bordered table-gray">
						<thead>
							<tr>
								<th colspan="2">Special Instructions for Suppliers</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="w-75 pt-2 valign-top">
									<div class="form-element-container">
										<textarea class="form-control" style="background-color: #ffffff !important" name="instructions"
											id="instructions" rows="3" maxlength="1500" formControlName="instructions">
										</textarea>
										<span class="form-text special-instructions-form-text">
											i.e. Customer Requests for Single Bill, Customer Needs 100% Green Energy, This is a Proxy Usage,
											or etc.
										</span>
									</div>
								</td>
								<td class="pt-2 valign-top enhance-checkboxes">
									<div class="form-element-container mt-0">
										<div class="custom-control custom-checkbox" *ngIf="!form.isCustomerInvited.disabled">
											<input class="custom-control-input" type="checkbox" id="isCustomerInvited"
												formControlName="isCustomerInvited" />
											<label class="custom-control-label" for="isCustomerInvited">Invite Customer</label>
										</div>
										<div *ngIf="form.isCustomerInvited.disabled"><label>Invited Customer!</label></div>
										<small>Will receive emails for when the pricing session begins, extends, and completes.</small>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-table table-responsive">
					<table class="table table-sm table-bordered table-striped">
						<thead>
							<tr>
								<th colspan="2">Special Instructions for Admin</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="w-75 pt-2 valign-top">
									<div class="form-element-container">
										<textarea class="form-control" style="background-color: #ffffff !important" name="instructionsAdmin"
											id="instructionsAdmin" rows="3" maxlength="1500" formControlName="instructionsAdmin">
										</textarea>
										<span class="form-text">i.e. Specific Supplier Instructions, Pricing Targets, etc.</span>
									</div>
								</td>
								<td class="pt-2 valign-top"></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<h6 class="supplier-note-header">Supplier Notes</h6>
			</div>
		</div>
		<ng-container *ngFor="let rfqSessionSupplier of rfqSession.suppliers">
			<div class="row" *ngIf="rfqSessionSupplier.hasNote || rfqSessionSupplier.optOutReasonType">
				<div class="col-sm-12">
					<div class="form-element-container">
						<label class="title supplier-note-title">
							{{ rfqSessionSupplier.supplier.name }} <ng-container *ngIf="rfqSessionSupplier.isOptOut">(Opt
								Out)</ng-container>
						</label>
						<div>
							<ng-container *ngIf="rfqSessionSupplier.loaRequestNote">
								<span class="p-0 supplier-note-body">
									{{ rfqSessionSupplier.loaRequestNote }} ({{ rfqSessionSupplier.loaRequestDate | date: 'MM/dd/yyyy' }})
								</span>
								<ng-container *ngIf="loggedInUser.isAdmin">
									<a href="javascript:void(0)" class="pl-2"
										(click)="showAuctionSupplierNoteEdit(rfqSessionSupplier, 'loaRequestNote', 'LOA Request Note')">
										<fa-icon [icon]="['fas', 'pencil-alt']" style="font-size: 14px"></fa-icon>Edit Note
									</a>
									<br /><br />
								</ng-container>
							</ng-container>
							<ng-container *ngIf="rfqSessionSupplier.loeRequestNote">
								<span class="p-0 supplier-note-body">
									{{ rfqSessionSupplier.loeRequestNote }} ({{ rfqSessionSupplier.loeRequestDate | date: 'MM/dd/yyyy' }})
								</span>
								<ng-container *ngIf="loggedInUser.isAdmin">
									<a href="javascript:void(0)" class="pl-2"
										(click)="showAuctionSupplierNoteEdit(rfqSessionSupplier, 'loeRequestNote', 'LOE Request Note')">
										<fa-icon [icon]="['fas', 'pencil-alt']" style="font-size: 14px"></fa-icon>Edit Note
									</a>
									<br /><br />
								</ng-container>
							</ng-container>
							<ng-container *ngIf="rfqSessionSupplier.sampleBillRequestNote">
								<span class="p-0 supplier-note-body">
									{{ rfqSessionSupplier.sampleBillRequestNote }} ({{ rfqSessionSupplier.sampleBillRequestDate | date:
									'MM/dd/yyyy' }})
								</span>
								<ng-container *ngIf="loggedInUser.isAdmin">
									<a href="javascript:void(0)" class="pl-2"
										(click)="showAuctionSupplierNoteEdit(rfqSessionSupplier, 'sampleBillRequestNote', 'Bill Request Note')">
										<fa-icon [icon]="['fas', 'pencil-alt']" style="font-size: 14px"></fa-icon>Edit Note
									</a>
									<br /><br />
								</ng-container>
							</ng-container>
							<span class="p-0 supplier-note-body" *ngIf="rfqSessionSupplier.note">
								{{ rfqSessionSupplier.note }} ({{ rfqSessionSupplier.noteAddDate | date: 'MM/dd/yyyy' }})
							</span>
							<ng-container *ngIf="loggedInUser.isAdmin">
								<a *ngIf="rfqSessionSupplier.note" href="javascript:void(0)" class="pl-2"
									(click)="showAuctionSupplierNoteEdit(rfqSessionSupplier, 'note', 'Note')">
									<fa-icon [icon]="['fas', 'pencil-alt']" style="font-size: 14px"></fa-icon>Edit Note
								</a>
								<a *ngIf="!rfqSessionSupplier.note" href="javascript:void(0)"
									(click)="showAuctionSupplierNoteEdit(rfqSessionSupplier, 'note', 'Note')">
									<fa-icon [icon]="['fas', 'plus']" style="font-size: 14px"></fa-icon>Add Note
								</a>
								<br /><br />
							</ng-container>
							<span class="p-0 supplier-note-body" *ngIf="rfqSessionSupplier.optOutReasonType">
								{{ rfqSessionSupplier.supplier.name }} has opted out of the pricing session: {{
								rfqSessionSupplier.optOutReasonType.name }}:
								{{ rfqSessionSupplier.optOutReasonNote }} ({{ rfqSessionSupplier.optOutReasonNoteAddDate | date:
								'MM/dd/yyyy' }})
								<ng-container *ngIf="!rfqSessionSupplier.isOptOut">
									<br /><br />
									{{ rfqSessionSupplier.supplier.name }} has opted back into the pricing session.
								</ng-container>
							</span>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</form>
